// Extracted from processMiner.js: functions that generate the node/link data for gDiagramPV
// These are parameterized via a `state` object so they can live in their own module.

export function generateNodes(nodeType, state) {
    const {
        gActivityArray,
        gLinkArray,
        gVariantArray,
        gVariantPaneVariants,
        gDetailActivity,
        gShowStartNode,
        gShowEndNode,
        gShowStartLabel,
        gShowEndLabel,
        gShowNodeTasks,
        gShowNodePercTotal,
        gDiagramPVTasks,
        gEntityUpper,
        gActivityShape,
        gNodeLabelFontSize,
        gColorStartNode,
        gColorEndNode,
        numberWithCommas
    } = state;
    let detailActivityTasks = 0;

    if (nodeType != 'variants') {
        if (nodeType == 'activity_inbound_all' || nodeType == 'activity_outbound_all') {
            for (let i = 0; i < gActivityArray.length; i++) {
                if (parseInt(gActivityArray[i].id) == parseInt(gDetailActivity)) {
                    detailActivityTasks = gActivityArray[i].tasks;
                }
            }
        }

        if (nodeType == 'activity_inbound_sliced') {
            for (let j = 0; j < gLinkArray.length; j++) {
                if (parseInt(gLinkArray[j].to) === parseInt(gDetailActivity) && gLinkArray[j].loop === false && gLinkArray[j].duplicate === false) {
                    let sliced = false;
                    for (let l = 0; l < gVariantArray.length; l++) {
                        if (gVariantArray[l].v == parseInt(gLinkArray[j].variant) && gVariantArray[l].sliced === true) {
                            sliced = true;
                        }
                    }
                    if (sliced === true) {
                        detailActivityTasks = detailActivityTasks + gLinkArray[j].tasks;
                    }
                }
            }
        }
        if (nodeType == 'activity_outbound_sliced') {
            for (let j = 0; j < gLinkArray.length; j++) {
                if (parseInt(gLinkArray[j].from) === parseInt(gDetailActivity) && gLinkArray[j].loop === false && gLinkArray[j].duplicate === false) {
                    let sliced = false;
                    for (let l = 0; l < gVariantArray.length; l++) {
                        if (gVariantArray[l].v == parseInt(gLinkArray[j].variant) && gVariantArray[l].sliced === true) {
                            sliced = true;
                        }
                    }
                    if (sliced === true) {
                        detailActivityTasks = detailActivityTasks + gLinkArray[j].tasks;
                    }
                }
            }
        }
        if (nodeType == 'activity_inbound_selected') {
            for (let j = 0; j < gLinkArray.length; j++) {
                if (parseInt(gLinkArray[j].to) === parseInt(gDetailActivity) && gLinkArray[j].loop === false && gLinkArray[j].duplicate === false) {
                    for (let l = 0; l < gVariantPaneVariants.length; l++) {
                        if (gVariantPaneVariants[l].v == parseInt(gLinkArray[j].variant)) {
                            detailActivityTasks = detailActivityTasks + gLinkArray[j].tasks;
                        }
                    }
                }
            }
        }
        if (nodeType == 'activity_outbound_selected') {
            for (let j = 0; j < gLinkArray.length; j++) {
                if (parseInt(gLinkArray[j].from) === parseInt(gDetailActivity) && gLinkArray[j].loop === false && gLinkArray[j].duplicate === false) {
                    for (let l = 0; l < gVariantPaneVariants.length; l++) {
                        if (gVariantPaneVariants[l].v == parseInt(gLinkArray[j].variant)) {
                            detailActivityTasks = detailActivityTasks + gLinkArray[j].tasks;
                        }
                    }
                }
            }
        }
    }

    let nodeArray = [
        { key: '', text: '', start_node: false, end_node: false, figure: 'Border', visible: true, font: 'bold 7pt system-ui, arial, system-ui' },
    ];
    nodeArray.length = 0;
    for (let i = 0; i < gActivityArray.length; i++) {
        let visible = gActivityArray[i].v;
        if (gActivityArray[i].start_node == true && gShowStartNode == false) {
            visible = false;
        }
        if (gActivityArray[i].end_node == true && gShowEndNode == false) {
            visible = false;
        }

        let vtp = {};
        vtp['key'] = gActivityArray[i].id.toString();
        let text = gActivityArray[i].activity;

        if (gActivityArray[i].activity != 'Start' && gActivityArray[i].activity != 'End') {
            if (nodeType != 'variants') {
                let stepTasks = 0;
                if (nodeType == 'activity_inbound_all') {
                    for (let j = 0; j < gLinkArray.length; j++) {
                        if (
                            parseInt(gLinkArray[j].to) == parseInt(gDetailActivity) &&
                            gLinkArray[j].duplicate === false &&
                            parseInt(gLinkArray[j].from) == parseInt(gActivityArray[i].id)
                        ) {
                            stepTasks = stepTasks + gLinkArray[j].tasks;
                        }
                    }
                }
                if (nodeType == 'activity_outbound_all') {
                    for (let j = 0; j < gLinkArray.length; j++) {
                        if (
                            parseInt(gLinkArray[j].to) == parseInt(gActivityArray[i].id) &&
                            parseInt(gLinkArray[j].from) == parseInt(gDetailActivity) &&
                            gLinkArray[j].duplicate === false &&
                            gLinkArray[j].end_node == false
                        ) {
                            stepTasks = stepTasks + gLinkArray[j].tasks;
                        }
                    }
                }
                if (nodeType == 'activity_inbound_sliced') {
                    for (let j = 0; j < gLinkArray.length; j++) {
                        if (
                            parseInt(gLinkArray[j].to) == parseInt(gDetailActivity) &&
                            parseInt(gLinkArray[j].from) == parseInt(gActivityArray[i].id) &&
                            gLinkArray[j].duplicate === false
                        ) {
                            let sliced = false;
                            for (let l = 0; l < gVariantArray.length; l++) {
                                if (gVariantArray[l].v == parseInt(gLinkArray[j].variant) && gVariantArray[l].sliced === true) {
                                    sliced = true;
                                }
                            }
                            if (sliced === true) {
                                stepTasks = stepTasks + gLinkArray[j].tasks;
                            }
                        }
                    }
                }
                if (nodeType == 'activity_outbound_sliced') {
                    for (let j = 0; j < gLinkArray.length; j++) {
                        if (
                            parseInt(gLinkArray[j].from) == parseInt(gDetailActivity) &&
                            parseInt(gLinkArray[j].to) == parseInt(gActivityArray[i].id) &&
                            gLinkArray[i].duplicate === false
                        ) {
                            let sliced = false;
                            for (let l = 0; l < gVariantArray.length; l++) {
                                if (gVariantArray[l].v == parseInt(gLinkArray[j].variant) && gVariantArray[l].sliced === true) {
                                    sliced = true;
                                }
                            }
                            if (sliced === true) {
                                stepTasks = stepTasks + gLinkArray[j].tasks;
                            }
                        }
                    }
                }
                if (nodeType == 'activity_inbound_selected') {
                    for (let j = 0; j < gLinkArray.length; j++) {
                        if (
                            parseInt(gLinkArray[j].to) == parseInt(gDetailActivity) &&
                            parseInt(gLinkArray[j].from) == parseInt(gActivityArray[i].id) &&
                            gLinkArray[j].duplicate === false
                        ) {
                            for (let l = 0; l < gVariantPaneVariants.length; l++) {
                                if (gVariantPaneVariants[l].v == parseInt(gLinkArray[j].variant)) {
                                    stepTasks = stepTasks + gLinkArray[j].tasks;
                                }
                            }
                        }
                    }
                }
                if (nodeType == 'activity_outbound_selected') {
                    for (let j = 0; j < gLinkArray.length; j++) {
                        if (
                            parseInt(gLinkArray[j].from) == parseInt(gDetailActivity) &&
                            parseInt(gLinkArray[j].to) == parseInt(gActivityArray[i].id) &&
                            gLinkArray[j].duplicate === false
                        ) {
                            for (let l = 0; l < gVariantPaneVariants.length; l++) {
                                if (gVariantPaneVariants[l].v == parseInt(gLinkArray[j].variant)) {
                                    stepTasks = stepTasks + gLinkArray[j].tasks;
                                }
                            }
                        }
                    }
                }

                if (gActivityArray[i].id == gDetailActivity) {
                    text = text + '\r\n' + numberWithCommas(detailActivityTasks);
                    vtp['tooltip'] =
                        'Activity: ' + gActivityArray[i].activity + '\r\n' + gEntityUpper + 's: ' + numberWithCommas(detailActivityTasks);
                    vtp['selected_activity'] = true;
                    vtp['tasks'] = detailActivityTasks;
                } else {
                    text = text + '\r\n' + numberWithCommas(stepTasks);
                    text = text + '\r\n' + parseFloat((stepTasks / detailActivityTasks) * 100).toFixed(1) + '%';
                    vtp['tooltip'] =
                        'Activity: ' +
                        gActivityArray[i].activity +
                        '\r\n' +
                        gEntityUpper +
                        's: ' +
                        numberWithCommas(stepTasks) +
                        '\r\n' +
                        ' % Total: ' +
                        parseFloat((stepTasks / detailActivityTasks) * 100).toFixed(1) +
                        '%';
                    vtp['selected_activity'] = false;
                    vtp['tasks'] = stepTasks;
                }
                vtp['activity'] = gActivityArray[i].activity;
                vtp['detailActivityTasks'] = detailActivityTasks;
                vtp['perc_total'] = ((stepTasks / detailActivityTasks) * 100).toFixed(2);
            }
            if (nodeType == 'variants') {
                if (gShowNodeTasks == true) {
                    text = text + '\r\n' + numberWithCommas(gActivityArray[i].selected_tasks);
                }
                if (gShowNodePercTotal == true) {
                    text = text + '\r\n' + parseFloat((gActivityArray[i].selected_tasks / gDiagramPVTasks) * 100).toFixed(1) + '%';
                }
                vtp['tooltip'] =
                    'Activity: ' +
                    gActivityArray[i].activity +
                    '\r\n' +
                    gEntityUpper +
                    's: ' +
                    numberWithCommas(gActivityArray[i].selected_tasks) +
                    '\r\n' +
                    ' % Total: ' +
                    parseFloat((gActivityArray[i].selected_tasks / gDiagramPVTasks) * 100).toFixed(1) +
                    '%';
            }
        }
        vtp['text'] = text
        if (gActivityArray[i].start_node === true && gShowStartLabel === false)  {vtp['text'] = ''}
        if (gActivityArray[i].end_node === true && gShowEndLabel === false)  {vtp['text'] = ''}
        vtp['activity'] = gActivityArray[i].activity;
        vtp['start_node'] = gActivityArray[i].start_node;
        vtp['end_node'] = gActivityArray[i].end_node;

        if (gActivityArray[i].activity == 'Start') {
            vtp['figure'] = 'Circle';
        }
        if (gActivityArray[i].activity == 'End') {
            vtp['figure'] = 'Circle';
        }
        if (gActivityArray[i].activity != 'Start' && gActivityArray[i].activity != 'End') {
            vtp['figure'] = gActivityShape;
        }

        if (gActivityArray[i].activity == 'Start' || gActivityArray[i].activity == 'End') {
            vtp['font'] = '6pt system-ui, arial, system-ui';
        } else {
            vtp['font'] = gNodeLabelFontSize + ' system-ui, arial, system-ui';
        }
        vtp['text_color'] = gActivityArray[i].color_text;
        vtp['visible'] = visible;
        vtp['highlight_color'] = gActivityArray[i].color_select;

        if (gActivityArray[i].activity == 'Start') {
            vtp['fill_color'] = gColorStartNode;
        }
        if (gActivityArray[i].activity == 'End') {
            vtp['fill_color'] = gColorEndNode;
        }
        if (gActivityArray[i].activity != 'Start' && gActivityArray[i].activity != 'End') {
            vtp['fill_color'] = gActivityArray[i].color_fill;
        }
        vtp['highlight_width'] = 3;
        nodeArray.push(vtp);
    }
    return nodeArray;
}

export function generateLinks(linkType, state) {
    const {
        gLinkArray,
        gVariantArray,
        gVariantPaneVariants,
        gActivityArray,
        gDetailActivity,
        gEntityUpper,
        gAnimateVariant,
        gLifecycleVariant,
        gIsolateVariant,
        gVariantLoops,
	        gDiagramPVTasks,
	        // gDiagramPV* counters are updated via `counters` to allow the caller
	        // (processMiner.js) to keep its module-level variables in sync.
	        counters,
        gShowStartNode,
        gShowEndNode,
        gShowStartLabel,
        gShowEndLabel,
        gShowLinkTasks,
        gShowLinkPercTotal,
        gShowLinkAvgDuration,
        gShowTooltipTasks,
        gShowTooltipPercTotal,
        gShowTooltipAvgDuration,
        gShowTooltipDeviation,
        gShowTooltipMaxDuration,
        gShowTooltipMinDuration,
        gShowTooltipCommentsInternal,
        gShowTooltipCommentsCustomer,
        gShowTooltipAvgCommentsInternal,
        gShowTooltipAvgCommentsCustomer,
        gShowTooltipWorklogs,
        gShowTooltipAvgWorklogs,
        gShowTooltipPercWorklogs,
        gShowTooltipPercCommentsInternal,
        gShowTooltipPercCommentsCustomer,
        gShowTooltipTotalTimespent,
        gShowTooltipAvgTimespent,
        gStepWidthTasks,
        gStepWidthDuration,
        gStepWidthStdDeviation,
        gStepLabelFontSize,
        gStepColourVolume,
        gStepColourDuration,
        gStepColourStdDeviation,
        gColorLink,
        gColorLinkSelect,
        gAnimateColor,
        gLoopColor,
        gLoopDashes,
        gHighlightLoops,
        numberWithCommas,
        formatDuration,
        formatDecimal,
        getStandardDeviation,
        getMedianDuration
    } = state;
    gLinkArray.sort((a, b) => a.variant - b.variant || a.sort_key - b.sort_key);
    let sdArray = [];
    let linkArray = [];
    let selectedVariants = [{ variant: 0, sequence: 0 }];
    selectedVariants.length = 0;
    // these are used to determine the width of a link, based on the metric defined as the width
    let minTasksDiagram = 1000000;
    let maxTasksDiagram = 0;
    let minDurationDiagram = 1000000000000;
    let maxDurationDiagram = 0;
    let minStdDeviationDiagram = 1000000000000;
    let maxStdDeviationDiagram = 0;

    let avgLinkDuration = 0;
    let minLinkDuration = 0;
    let maxLinkDuration = 0;
    let linkTasks = 0;
    let linkDuration = 0;
    let loop = false;

    let j = 0;
    let animateVariant = null;
    let lifecycleVariant = null;
    let isolateVariant = null;

    if (linkType === 'variants') {
        if (gAnimateVariant != 0) {
            for (let i = 0; i < gVariantArray.length; i++) {
                if (gVariantArray[i].s == gAnimateVariant) {
                    animateVariant = gVariantArray[i].v;
                }
            }
        }

        if (gLifecycleVariant != 0) {
            for (let i = 0; i < gVariantArray.length; i++) {
                if (gVariantArray[i].s == gLifecycleVariant) {
                    lifecycleVariant = gVariantArray[i].v;
                }
            }
        }
        if (gIsolateVariant != 0) {
            for (let i = 0; i < gVariantArray.length; i++) {
                if (gVariantArray[i].s == gIsolateVariant) {
                    isolateVariant = gVariantArray[i].v;
                }
            }
        }
    }
    let i = 0;
    for (i = 0; i < gLinkArray.length; i++) {
        if (gLinkArray[i].duplicate === false) {
            let validLink = false;
            if (linkType === 'variants') {
                let variant = parseInt(gLinkArray[i].variant);

                let validVariant = false;

                if (isolateVariant == null) {
                    for (j = 0; j < gVariantPaneVariants.length; j++) {
                        if (variant == gVariantPaneVariants[j].v) {
                            validVariant = true;
                            break;
                        }
                    }
                }
                if (isolateVariant != null && variant == isolateVariant) {
                    validVariant = true;
                }

                if (validVariant == true) {
                    validLink = true;

                    for (let l = 0; l < gVariantArray.length; l++) {
                        if (gVariantArray[l].v == variant) {
                            if (gVariantLoops == true && gVariantArray[l].l == false) {
                                validLink = false;
                            }
                            if (gVariantLoops == false && gVariantArray[l].l == true) {
                                validLink = false;
                            }
                            if (validLink == false) {
                                break;
                            }
                        }
                    }
                }
            }

            if (linkType === 'activity_inbound_all') {
                if (parseInt(gDetailActivity) === parseInt(gLinkArray[i].to)) {
                    validLink = true;
                }
            }

            if (linkType === 'activity_inbound_sliced') {
                let variant = parseInt(gLinkArray[i].variant);
                let sliced = false;
                for (let l = 0; l < gVariantArray.length; l++) {
                    if (gVariantArray[l].v === variant && gVariantArray[l].sliced === true) {
                        sliced = true;
                    }
                }
                if (parseInt(gDetailActivity) === parseInt(gLinkArray[i].to) && sliced === true) {
                    validLink = true;
                }
            }

            if (linkType === 'activity_inbound_selected') {
                let variant = parseInt(gLinkArray[i].variant);
                let sliced = false;
                for (let l = 0; l < gVariantPaneVariants.length; l++) {
                    if (gVariantPaneVariants[l].v === variant) {
                        sliced = true;
                    }
                }
                if (parseInt(gDetailActivity) === parseInt(gLinkArray[i].to) && sliced === true) {
                    validLink = true;
                }
            }

            if (linkType === 'activity_outbound_all' && gLinkArray[i].end_node != true) {
                if (parseInt(gDetailActivity) === parseInt(gLinkArray[i].from)) {
                    validLink = true;
                }
            }
            if (linkType === 'activity_outbound_sliced' && gLinkArray[i].end_node != true) {
                let variant = parseInt(gLinkArray[i].variant);
                let sliced = false;
                for (let l = 0; l < gVariantArray.length; l++) {
                    if (gVariantArray[l].v == variant && gVariantArray[l].sliced === true) {
                        sliced = true;
                    }
                }
                if (parseInt(gDetailActivity) === parseInt(gLinkArray[i].from) && sliced === true) {
                    validLink = true;
                }
            }

            if (linkType === 'activity_outbound_selected') {
                let variant = parseInt(gLinkArray[i].variant);
                let sliced = false;
                for (let l = 0; l < gVariantPaneVariants.length; l++) {
                    if (gVariantPaneVariants[l].v === variant) {
                        sliced = true;
                    }
                }
                if (parseInt(gDetailActivity) === parseInt(gLinkArray[i].from) && sliced === true) {
                    validLink = true;
                }
            }

            if (validLink == true) {
                let exists = false;
                minLinkDuration = 0;
                maxLinkDuration = 0;

                let z = 0;
                for (let k = 0; k < linkArray.length; k++) {
                    if (gLinkArray[i].from == linkArray[k].from) {
                        if (gLinkArray[i].to == linkArray[k].to) {
                            linkTasks = gLinkArray[i].tasks;
                            linkDuration = gLinkArray[i].duration;
                            loop = gLinkArray[i].loop;
                            sdArray = gLinkArray[i].sd_array;
                            exists = true;
                            z = k;
                            break;
                        }
                    }
                }

                if (exists == true) {
                    linkArray[z].tasks = linkArray[z].tasks + linkTasks;
                    if (gLinkArray[i].loop == false) {
                        linkArray[z].distinct_tasks = linkArray[z].distinct_tasks + linkTasks;
                    }
                    linkArray[z].duration = linkArray[z].duration + linkDuration;
                    linkArray[z].avg_duration = linkArray[z].duration / linkArray[z].tasks;
                    linkArray[z].sd_array = linkArray[z].sd_array.concat(sdArray);

                    linkArray[z].loop = loop;

                    if (minLinkDuration > linkArray[z].min_duration) {
                        minLinkDuration = linkArray[z].min_duration;
                    }
                    if (maxLinkDuration < linkArray[z].max_duration) {
                        maxLinkDuration = linkArray[z].max_duration;
                    }

                    if (minTasksDiagram > linkArray[z].tasks) {
                        minTasksDiagram = linkArray[z].tasks;
                    }
                    if (maxTasksDiagram < linkArray[z].tasks) {
                        maxTasksDiagram = linkArray[z].tasks;
                    }
                    if (gLinkArray[i].start_node === false && gLinkArray[i].end_node === false) {
                        if (minDurationDiagram > linkArray[z].avg_duration) {
                            minDurationDiagram = linkArray[z].avg_duration;
                        }
                        if (maxDurationDiagram < linkArray[z].avg_duration) {
                            maxDurationDiagram = linkArray[z].avg_duration;
                        }
                    }
                    if (minStdDeviationDiagram > getStandardDeviation(linkArray[z].sd_array)) {
                        minStdDeviationDiagram = getStandardDeviation(linkArray[z].sd_array);
                    }
                    if (maxStdDeviationDiagram < getStandardDeviation(linkArray[z].sd_array)) {
                        maxStdDeviationDiagram = getStandardDeviation(linkArray[z].sd_array);
                    }
                } else {
                    avgLinkDuration = gLinkArray[i].duration / gLinkArray[i].tasks;
                    minLinkDuration = gLinkArray[i].min_duration;
                    maxLinkDuration = gLinkArray[i].max_duration;

                    if (minTasksDiagram > gLinkArray[i].tasks) {
                        minTasksDiagram = gLinkArray[i].tasks;
                    }
                    if (maxTasksDiagram < gLinkArray[i].tasks) {
                        maxTasksDiagram = gLinkArray[i].tasks;
                    }
                    if (gLinkArray[i].start_node === false && gLinkArray[i].end_node === false) {
                        if (minDurationDiagram > avgLinkDuration) {
                            minDurationDiagram = avgLinkDuration;
                        }
                        if (maxDurationDiagram < avgLinkDuration) {
                            maxDurationDiagram = avgLinkDuration;
                        }
                    }
                    if (minStdDeviationDiagram > getStandardDeviation(gLinkArray[i].sd_array)) {
                        minStdDeviationDiagram = getStandardDeviation(gLinkArray[i].sd_array);
                    }
                    if (maxStdDeviationDiagram < getStandardDeviation(gLinkArray[i].sd_array)) {
                        maxStdDeviationDiagram = getStandardDeviation(gLinkArray[i].sd_array);
                    }

                    let vtp = {};
                    vtp['from'] = gLinkArray[i].from.toString();
                    vtp['to'] = gLinkArray[i].to.toString();
                    vtp['from_label'] = gLinkArray[i].from_label;
                    vtp['to_label'] = gLinkArray[i].to_label;
                    vtp['variant'] = gLinkArray[i].variant;
                    vtp['width'] = 1;
                    vtp['start_node'] = gLinkArray[i].start_node;
                    vtp['end_node'] = gLinkArray[i].end_node;
                    vtp['visible'] = true;
                    vtp['label_visible'] = true;
                    if (gLinkArray[i].start_node == true || gLinkArray[i].end_node == true) {
                        vtp['dashes'] = true;
                    } else {
                        vtp['dashes'] = false;
                    }
                    vtp['loop'] = gLinkArray[i].loop;
                    vtp['animate'] = false;
                    vtp['font'] = gStepLabelFontSize + ' system-ui, arial, system-ui';
                    vtp['tasks'] = gLinkArray[i].tasks;
                    if (vtp['loop'] == false) {
                        vtp['distinct_tasks'] = gLinkArray[i].tasks;
                    } else {
                        vtp['distinct_tasks'] = 0;
                    }
                    vtp['duration'] = gLinkArray[i].duration;
                    vtp['min_duration'] = minLinkDuration;
                    vtp['max_duration'] = maxLinkDuration;
                    vtp['avg_duration'] = avgLinkDuration;
                    vtp['sd_array'] = gLinkArray[i].sd_array;
                    vtp['comment_internal_ctr'] = gLinkArray[i].comment_internal_ctr;
                    vtp['avg_internal_comments'] = gLinkArray[i].comment_internal_ctr/gLinkArray[i].tasks;
                    vtp['comment_customer_ctr'] = gLinkArray[i].comment_customer_ctr;
                    vtp['avg_customer_comments'] = gLinkArray[i].comment_customer_ctr/gLinkArray[i].tasks;
                    vtp['worklog_ctr'] = gLinkArray[i].worklog_ctr;
                    vtp['avg_worklogs'] = gLinkArray[i].worklog_ctr/gLinkArray[i].tasks;
                    vtp['tasks_worklog'] = gLinkArray[i].tasks_worklog
                    vtp['tasks_comments_customer'] = gLinkArray[i].tasks_comments_customer
                    vtp['tasks_comments_internal'] = gLinkArray[i].tasks_comments_internal
                    linkArray.push(vtp);
                    j++;
                }
            }
        }
    }
    let widths_num = 9;
    let width_increments = 0.5;
    let width_min = 1;

    let gap = 0;
    if (gStepWidthTasks == true) {
        gap = Math.ceil((maxTasksDiagram - minTasksDiagram) / widths_num);
    }
    if (gStepWidthDuration == true) {
        gap = Math.ceil((maxDurationDiagram - minDurationDiagram) / widths_num);
    }
    if (gStepWidthStdDeviation == true) {
        gap = Math.ceil((maxStdDeviationDiagram - minStdDeviationDiagram) / widths_num);
    }

	    // Reset diagram counters for this link generation run
	    if (counters) {
	        counters.steps = 0;
	        counters.loops = 0;
	        counters.taskLoops = 0;
	        counters.activities = 0;
	    }
    let tempActivities = [];

    let detailActivityTasks = 0;

    if (linkType != 'variants') {
        if (linkType == 'activity_inbound_all' || linkType == 'activity_outbound_all') {
            for (let i = 0; i < gActivityArray.length; i++) {
                if (parseInt(gActivityArray[i].id) == parseInt(gDetailActivity)) {
                    detailActivityTasks = gActivityArray[i].tasks;
                }
            }
        }

        if (linkType == 'activity_inbound_sliced') {
            for (let j = 0; j < gLinkArray.length; j++) {
                if (parseInt(gLinkArray[j].to) === parseInt(gDetailActivity) && gLinkArray[j].loop === false && gLinkArray[j].duplicate === false) {
                    let sliced = false;
                    for (let l = 0; l < gVariantArray.length; l++) {
                        if (gVariantArray[l].v == parseInt(gLinkArray[j].variant) && gVariantArray[l].sliced === true) {
                            sliced = true;
                        }
                    }
                    if (sliced === true) {
                        detailActivityTasks = detailActivityTasks + gLinkArray[j].tasks;
                    }
                }
            }
        }
        if (linkType == 'activity_outbound_sliced') {
            for (let j = 0; j < gLinkArray.length; j++) {
                if (parseInt(gLinkArray[j].from) === parseInt(gDetailActivity) && gLinkArray[j].loop === false && gLinkArray[j].duplicate === false) {
                    let sliced = false;
                    for (let l = 0; l < gVariantArray.length; l++) {
                        if (gVariantArray[l].v == parseInt(gLinkArray[j].variant) && gVariantArray[l].sliced === true) {
                            sliced = true;
                        }
                    }
                    if (sliced === true) {
                        detailActivityTasks = detailActivityTasks + gLinkArray[j].tasks;
                    }
                }
            }
        }
        if (linkType == 'activity_inbound_selected') {
            for (let j = 0; j < gLinkArray.length; j++) {
                if (parseInt(gLinkArray[j].to) === parseInt(gDetailActivity) && gLinkArray[j].loop === false && gLinkArray[j].duplicate === false) {
                    for (let l = 0; l < gVariantPaneVariants.length; l++) {
                        if (gVariantPaneVariants[l].v == parseInt(gLinkArray[j].variant)) {
                            detailActivityTasks = detailActivityTasks + gLinkArray[j].tasks;
                        }
                    }
                }
            }
        }
        if (linkType == 'activity_outbound_selected') {
            for (let j = 0; j < gLinkArray.length; j++) {
                if (parseInt(gLinkArray[j].from) === parseInt(gDetailActivity) && gLinkArray[j].loop === false && gLinkArray[j].duplicate === false) {
                    for (let l = 0; l < gVariantPaneVariants.length; l++) {
                        if (gVariantPaneVariants[l].v == parseInt(gLinkArray[j].variant)) {
                            detailActivityTasks = detailActivityTasks + gLinkArray[j].tasks;
                        }
                    }
                }
            }
        }
    }
    let colorArr = ['#198C00', '#4BA500', '#7DBF00', '#AED700', '#EBF500', '#FFE800', '#FFB401', '#FF8100', '#FF4F00', '#FF1A00'];
    let durationColourGap = Math.ceil((maxDurationDiagram - minDurationDiagram) / 9);
    let tasksColourGap = Math.ceil((maxTasksDiagram - minTasksDiagram) / 9);
    let stdDeviationColourGap = Math.ceil((maxStdDeviationDiagram - minStdDeviationDiagram) / 9);
    for (let i = 0; i < linkArray.length; i++) {
        linkArray[i].std_deviation = getStandardDeviation(linkArray[i].sd_array);
        linkArray[i].med_duration = getMedianDuration(linkArray[i].sd_array);

        if (linkArray[i].end_node == false) {
	            if (counters) counters.steps++;
        }
        let tasks = linkArray[i].tasks;

        if (gStepWidthTasks == true) {
            for (j = 1; j <= widths_num; j++) {
                if (tasks <= minTasksDiagram + j * gap) {
                    linkArray[i].width = width_min - width_increments + j * width_increments;
                    break;
                }
            }
        }
        if (gStepWidthDuration == true) {
            for (j = 1; j <= widths_num; j++) {
                if (linkArray[i].avg_duration <= minDurationDiagram + j * gap) {
                    linkArray[i].width = width_min - width_increments + j * width_increments;
                    break;
                }
            }
        }
        if (gStepWidthStdDeviation == true) {
            for (j = 1; j <= widths_num; j++) {
                if (linkArray[i].std_deviation <= minStdDeviationDiagram + j * gap) {
                    linkArray[i].width = width_min - width_increments + j * width_increments;
                    break;
                }
            }
        }
        if (linkType != 'variants') {
            linkArray[i].perc_total = parseFloat((linkArray[i].tasks / detailActivityTasks) * 100).toFixed(1) + '%';
        }

        if (linkType == 'variants') {
            linkArray[i].perc_total = parseFloat((linkArray[i].tasks / gDiagramPVTasks) * 100).toFixed(1) + '%';
        }
        linkArray[i].link_label = '';

        if (linkArray[i].start_node == false && linkArray[i].end_node == false) {
            if (gShowLinkTasks == true && linkType == 'variants') {
                if (linkArray[i].link_label.length >= 1) {
                    linkArray[i].link_label = linkArray[i].link_label + '\r\n';
                }
                linkArray[i].link_label = linkArray[i].link_label + numberWithCommas(linkArray[i].tasks);
            }
            if (gShowLinkPercTotal == true && linkType == 'variants') {
                if (linkArray[i].link_label.length >= 1) {
                    linkArray[i].link_label = linkArray[i].link_label + '\r\n';
                }
                linkArray[i].link_label = linkArray[i].link_label + linkArray[i].perc_total;
            }
            if (gShowLinkAvgDuration == true) {
                if (linkArray[i].link_label.length >= 1) {
                    linkArray[i].link_label = linkArray[i].link_label + '\r\n';
                }
                linkArray[i].link_label = linkArray[i].link_label + formatDuration(linkArray[i].avg_duration);
            }
        }
        if (
            (linkArray[i].start_node == true && gShowStartLabel == true && gShowStartNode == true) ||
            (linkArray[i].end_node == true && gShowEndLabel == true && gShowEndNode == true)
        ) {
            if (gShowLinkTasks == true) {
                if (linkArray[i].link_label.length >= 1) {
                    linkArray[i].link_label = linkArray[i].link_label + '\r\n';
                }
                linkArray[i].link_label = linkArray[i].link_label + numberWithCommas(linkArray[i].tasks);
            }
            if (gShowLinkPercTotal == true) {
                if (linkArray[i].link_label.length >= 1) {
                    linkArray[i].link_label = linkArray[i].link_label + '\r\n';
                }
                linkArray[i].link_label = linkArray[i].link_label + linkArray[i].perc_total;
            }
        }

        linkArray[i].link_color = gColorLink;
        if (linkArray[i].start_node == true && gShowStartLabel == false) {
            linkArray[i].label_visible = false;
        }
        if (linkArray[i].end_node == true && gShowEndLabel == false) {
            linkArray[i].label_visible = false;
        }
        if (animateVariant == 0) {
            if (gLoopDashes == true && linkArray[i].loop == true) {
                linkArray[i].dashes = true;
                linkArray[i].animate = true;
            } else {
                linkArray[i].dashes = false;
            }
        }
        if (lifecycleVariant == 0) {
            if (gLoopDashes == true && linkArray[i].loop == true) {
                linkArray[i].lifecycle = true;
            } else {
                linkArray[i].lifecycle = false;
            }
        }

        if (linkArray[i].loop == true) {
	            if (counters) counters.loops++;
        }
        if (linkArray[i].loop == true && gHighlightLoops == true) {
            linkArray[i].link_color = gLoopColor;
        }
        if (linkType == 'variants') {

            linkArray[i].highlight_color = gColorLinkSelect;
        }
        linkArray[i].visible = true;

        if (gStepColourVolume === true) {
            if (linkArray[i].start_node === true || linkArray[i].end_node === true) {
                linkArray[i].link_color = '#9B9B9B';
            } else {
                for (let j = 0; j < 10; j++) {
                    if (linkArray[i].tasks <= minTasksDiagram + j * tasksColourGap) {
                        linkArray[i].link_color = colorArr[j];
                        break;
                    }
                }
            }
        }

        if (gStepColourDuration === true) {
            if (linkArray[i].start_node === true || linkArray[i].end_node === true) {
                linkArray[i].link_color = '#9B9B9B';
            } else {
                for (let j = 0; j < 10; j++) {
                    if (linkArray[i].avg_duration <= minDurationDiagram + j * durationColourGap) {
                        linkArray[i].link_color = colorArr[j];
                        break;
                    }
                }
            }
        }

        if (gStepColourStdDeviation === true) {
            if (linkArray[i].start_node === true || linkArray[i].end_node === true) {
                linkArray[i].link_color = '#9B9B9B';
            } else {
                for (let j = 0; j < 10; j++) {
                    if (linkArray[i].std_deviation <= minStdDeviationDiagram + j * stdDeviationColourGap) {
                        linkArray[i].link_color = colorArr[j];
                        break;
                    }
                }
            }
        }

        if (linkArray[i].start_node == true && gShowStartNode == false) {
            linkArray[i].visible = false;
            linkArray[i].link_color = 'white';
        }
        if (linkArray[i].end_node == true && gShowEndNode == false) {
            linkArray[i].visible = false;
            linkArray[i].link_color = 'white';
        }
        linkArray[i].tooltip =
            'From: ' +
            linkArray[i].from_label +
            '\r\n' +
            'To: ' +
            linkArray[i].to_label 

        if (linkArray[i].start_node != true && linkArray[i].end_node != true) {

            if (gShowTooltipTasks === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +
                '\r\n' +
                gEntityUpper + 's: ' +
                linkArray[i].tasks
            }
            if (gShowTooltipPercTotal === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +
                '\r\n' +
                '% Total: ' +
                linkArray[i].perc_total;
            }
            if (gShowTooltipAvgDuration === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +             
                 '\r\n' +
                'Avg Duration: ' +
                formatDuration(linkArray[i].avg_duration) 
            }
            if (gShowTooltipDeviation === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Std Deviation: ' +
                formatDuration(linkArray[i].std_deviation) 
            }
            if (gShowTooltipMaxDuration === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Max Duration: ' +
                formatDuration(linkArray[i].max_duration)
            }
            if (gShowTooltipMinDuration === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Min Duration: ' +
                formatDuration(linkArray[i].min_duration);
            }

            if (gShowTooltipCommentsCustomer === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Customer Comments: ' +
                linkArray[i].comment_customer_ctr;
            }
            if (gShowTooltipAvgCommentsCustomer === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Avg Customer Comments: ' +
                linkArray[i].comment_customer_ctr/linkArray[i].tasks;
            }
            if (gShowTooltipPercCommentsCustomer === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                '% Tasks Customer Comments: ' +
                formatPercentage(linkArray[i].tasks_comments_customer/linkArray[i].tasks,1);
            }
            if (gShowTooltipCommentsInternal === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Internal Comments: ' +
                linkArray[i].comment_internal_ctr;
            }
            if (gShowTooltipAvgCommentsInternal === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Avg Internal Comments: ' +
                linkArray[i].comment_internal_ctr/linkArray[i].tasks;
            }
            if (gShowTooltipPercCommentsInternal === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                '% Tasks Internal Comments: ' +
                formatPercentage(linkArray[i].tasks_comments_internal/linkArray[i].tasks,1);
            }
            if (gShowTooltipWorklogs === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Total Worklogs: ' +
                linkArray[i].worklog_ctr;
            }
            if (gShowTooltipAvgWorklogs === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Avg Worklogs: ' +
                linkArray[i].worklog_ctr/linkArray[i].tasks;
            }

            if (gShowTooltipPercWorklogs === true) { 
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                '% Tasks Worklogs: ' +
                formatPercentage(linkArray[i].tasks_worklog/linkArray[i].tasks,1)
            }

            if (gShowTooltipTotalTimespent === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Total Timespent: ' +
                formatDuration(linkArray[i].time_spent)
            }
            if (gShowTooltipAvgTimespent === true) {
                linkArray[i].tooltip = linkArray[i].tooltip +    
                '\r\n' +
                'Avg Timespent: ' +
                 formatDuration(linkArray[i].time_spent/linkArray[i].tasks)
            }
        }

        let activityExists = false;
        for (let j = 0; j < tempActivities.length; j++) {
            if (tempActivities[j].a == linkArray[i].from) {
                activityExists = true;
                break;
            }
        }
        if (activityExists == false) {
            let vtp = {};
            vtp['a'] = linkArray[i].from;
            tempActivities.push(vtp);
        }
        activityExists = false;
        for (let j = 0; j < tempActivities.length; j++) {
            if (tempActivities[j].a == linkArray[i].to) {
                activityExists = true;
                break;
            }
        }
        if (activityExists == false) {
            let vtp = {};
            vtp['a'] = linkArray[i].to;
            tempActivities.push(vtp);
        }
    }

    if (linkType === 'variants') {
	        if (counters) counters.activities = tempActivities.length - 2;

        if (animateVariant != null) {
            for (let i = 0; i < gLinkArray.length; i++) {
                if (gLinkArray[i].variant == animateVariant && gLinkArray[i].duplicate === false) {
                    for (j = 0; j < linkArray.length; j++) {
                        if (linkArray[j].from == gLinkArray[i].from && linkArray[j].to == gLinkArray[i].to) {
                            linkArray[j].width = 4;
                            linkArray[j].link_color = gAnimateColor;
                            linkArray[j].animate = true;
                            linkArray[j].dashes = true;
                        }
                    }
                }
            }
        }
        if (lifecycleVariant != null) {
            for (let i = 0; i < gLinkArray.length; i++) {
                if (gLinkArray[i].variant == lifecycleVariant && gLinkArray[i].duplicate === false) {
                    for (j = 0; j < linkArray.length; j++) {
                        if (linkArray[j].from == gLinkArray[i].from && linkArray[j].to == gLinkArray[i].to) {
                            linkArray[j].lifecycle = true;
                        }
                    }
                }
            }
        }
    }

    if (linkArray.length > 0) {
        let tempArray = [];
        for (let i = 0; i < linkArray.length; i++) {
            let vtp = {};
            vtp['a'] = linkArray[i].to;
            vtp['t'] = linkArray[i].distinct_tasks;
            tempArray.push(vtp);
        }

        tempArray.sort((a, b) => a.a - b.a);
        let tasks = 0;
        for (let i = 0; i < tempArray.length; i++) {
            if (i > 0 && tempArray[i - 1].a != tempArray[i].a) {
                for (let j = 0; j < gActivityArray.length; j++) {
                    if (gActivityArray[j].id == tempArray[i - 1].a) {
                        gActivityArray[j].selected_tasks = tasks;
                        break;
                    }
                }
                tasks = 0;
            }
            tasks = tempArray[i].t + tasks;
        }
        for (let j = 0; j < gActivityArray.length; j++) {
            if (gActivityArray[j].id == tempArray[tempArray.length - 1].a) {
                gActivityArray[j].selected_tasks = tasks;
                break;
            }
        }
    }
    return linkArray;
}
